module.exports = __webpack_public_path__ + "img/chat-hover-icon.b5cf19e1.png";